var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"max-w-7xl mx-auto px-3 mt-6 text-left"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }